import gql from 'graphql-tag'
import { ObservableQuery } from '@apollo/client'
import { apolloClientPrivate } from '../../../graphql/apolloClient'

export interface IVariables {
  topicId: number
}

export interface IResponse {
  data: {
    topic: {
      id: number
      draftVersion: {
        id: number
        scormCourse: {
          id: number
          courseStatus: {
            status: string
            job_details: Record<string, unknown>
            file_details: Record<string, unknown>
          }
        }
      }
    }
  }
}

export default (variables: IVariables): ObservableQuery => {
  const query = gql`
    query workspace($topicId: PositiveInt!) {
      topic(id: $topicId) {
        id
        ... on TopicModelAsEditor {
          draftVersion {
            id
            scormCourse {
              id
              courseStatus {
                id
                status
                job_details
                file_details
              }
            }
          }
        }
      }
    }
  `

  return apolloClientPrivate.watchQuery<ObservableQuery>({
    variables,
    query,
    pollInterval: 5000,
    fetchPolicy: 'network-only'
  })
}
